import { ModalFooter } from "react-bootstrap";
import styled from "styled-components";

const StyledModalTitle = styled.h4`
    font-weight: 700;
    font-size: 24px;
    line-height: 130%;
    color: #1e1e1e;
    margin-bottom: 24px;
`;

const StyledTextInfo = styled.h4`
    font-size: 22px;
`;

const StyledModalText = styled.h4`
    font-weight: 400;
    font-size: 17px;
    padding: 24px 0px;
`;

const StyledModalFooter = styled(ModalFooter)`
    border-top: none !important;
    padding-bottom: 20px;
    justify-content: center;
`;

const StyledModalFooterLink = styled.a`
    font-size: 16px;
    line-height: 100%;
    text-decoration: none;
    color: #8a0538;
    cursor: pointer;
    &:hover {
        color: #9654ff;
    }
`;

export default {
    StyledModalTitle,
    StyledTextInfo,
    StyledModalText,
    StyledModalFooter,
    StyledModalFooterLink,
};
